import Plugin from 'src/plugin-system/plugin.class';
export default class OverflowNavigationPlugin extends Plugin {
    init() {
        this.isTechnicalTable = this.el.hasAttribute('data-technical-table');
        this.technicalTables = this.el.querySelectorAll('.cms-element-technicals-table');
        this.overflowDiv = this.el.querySelector('[data-overflow-navigation]');
        this.overflowOffset = this.overflowOffset = parseInt(this.el.getAttribute('data-overflow-navigation-scroll-offset') || '100');
        this._insertButtons();
        this.prevButton = this.el.querySelectorAll('.overflow-navigation-arrow--prev');
        this.nextButton = this.el.querySelectorAll('.overflow-navigation-arrow--next');
        if (this.overflowDiv && this.prevButton && this.nextButton) {
            this._registerEvents();
        }
    }
    _registerEvents() {
        window.addEventListener('load', this._initButtons.bind(this), false);
        window.addEventListener('resize', this._initButtons.bind(this), false);
        this.overflowDiv?.addEventListener('wheel', this._initButtons.bind(this), false);
        this.prevButton?.forEach(button => {
            button.addEventListener('click', this._scrollLeft.bind(this), false);
            button.addEventListener('click', this._initButtons.bind(this), false);
        });
        this.nextButton?.forEach(button => {
            button.addEventListener('click', this._scrollRight.bind(this), false);
            button.addEventListener('click', this._initButtons.bind(this), false);
        });
    }
    _insertButtons() {
        let prevButton = '<button class="tw-hidden overflow-navigation-arrow overflow-navigation-arrow--prev"><span class="icon icon-arrow-medium-right icon-sm icon- icon- icon- icon-"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"><use transform="rotate(-90 8 8)" xlink:href="#icons-solid-arrow-medium-right" fill="currentColor" fill-rule="evenodd"></use></svg></span></button>';
        let nextButton = '<button class="tw-hidden overflow-navigation-arrow overflow-navigation-arrow--next"><span class="icon icon-arrow-medium-right icon-sm icon- icon- icon- icon-"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"><use transform="rotate(-90 8 8)" xlink:href="#icons-solid-arrow-medium-right" fill="currentColor" fill-rule="evenodd"></use></svg></span></button>';
        if (this.isTechnicalTable && this.technicalTables) {
            prevButton =
                '<button class="overflow-navigation-arrow overflow-navigation-arrow--prev btn btn-primary btn-icon" disabled><span class="icon icon-arrow-medium-right icon-sm icon- icon- icon- icon-"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"><use transform="rotate(-90 8 8)" xlink:href="#icons-solid-arrow-medium-right" fill="currentColor" fill-rule="evenodd"></use></svg></span></button>';
            nextButton =
                '<button class="overflow-navigation-arrow overflow-navigation-arrow--next btn btn-primary btn-icon" disabled><span class="icon icon-arrow-medium-right icon-sm icon- icon- icon- icon-"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"><use transform="rotate(-90 8 8)" xlink:href="#icons-solid-arrow-medium-right" fill="currentColor" fill-rule="evenodd"></use></svg></span></button>';
            this.technicalTables.forEach(table => {
                const buttonDiv = document.createElement('div');
                buttonDiv.classList.add('overflow-navigation-button-wrapper', 'tw-sticky', 'tw-left-0', 'tw-flex', 'tw-justify-end', 'tw-gap-2');
                buttonDiv.insertAdjacentHTML('beforeend', prevButton);
                buttonDiv.insertAdjacentHTML('beforeend', nextButton);
                table.parentNode?.insertBefore(buttonDiv, table.nextSibling);
            });
            return;
        }
        this.el.insertAdjacentHTML('beforeend', prevButton);
        this.el.insertAdjacentHTML('beforeend', nextButton);
    }
    _initButtons() {
        if (this.overflowDiv && this._hasHorizontalOverflow(this.overflowDiv)) {
            this.el.classList.add('has--overflow');
            if (this.overflowDiv && this.overflowDiv.scrollLeft > 0) {
                this._showPrevButton();
            }
            else {
                this._hidePrevButton();
            }
            if (this.overflowDiv &&
                this.overflowDiv.scrollLeft + this.overflowDiv.clientWidth >= this.overflowDiv.scrollWidth - 1) {
                this._hideNextButton();
            }
            else {
                this._showNextButton();
            }
        }
        else {
            this.el.classList.remove('has--overflow');
        }
    }
    _hasHorizontalOverflow(element) {
        if (element) {
            return element.scrollWidth > element.clientWidth;
        }
    }
    _scrollLeft() {
        if (this.overflowDiv) {
            this.overflowDiv.scrollTo({
                left: this.overflowDiv.scrollLeft - this.overflowOffset,
                behavior: 'smooth',
            });
            setTimeout(() => {
                this._initButtons();
            }, 500);
        }
    }
    _scrollRight() {
        if (this.overflowDiv) {
            this.overflowDiv.scrollTo({
                left: this.overflowDiv.scrollLeft + this.overflowOffset,
                behavior: 'smooth',
            });
            setTimeout(() => {
                this._initButtons();
            }, 500);
        }
    }
    _showNextButton() {
        this.nextButton?.forEach(button => {
            if (this.isTechnicalTable && this.technicalTables) {
                button.removeAttribute('disabled');
                button.classList.remove('disabled');
                return;
            }
            button.classList.remove('tw-hidden');
        });
    }
    _hideNextButton() {
        this.nextButton?.forEach(button => {
            if (this.isTechnicalTable && this.technicalTables) {
                button.setAttribute('disabled', '');
                button.classList.add('disabled');
                return;
            }
            button.classList.add('tw-hidden');
        });
    }
    _showPrevButton() {
        this.prevButton?.forEach(button => {
            if (this.isTechnicalTable && this.technicalTables) {
                button.removeAttribute('disabled');
                button.classList.remove('disabled');
                return;
            }
            button.classList.remove('tw-hidden');
        });
    }
    _hidePrevButton() {
        this.prevButton?.forEach(button => {
            if (this.isTechnicalTable && this.technicalTables) {
                button.setAttribute('disabled', '');
                button.classList.add('disabled');
                return;
            }
            button.classList.add('tw-hidden');
        });
    }
}
